import { render, staticRenderFns } from "./AIVTable.vue?vue&type=template&id=284b0348&scoped=true"
import script from "./AIVTable.vue?vue&type=script&lang=js"
export * from "./AIVTable.vue?vue&type=script&lang=js"
import style0 from "./AIVTable.vue?vue&type=style&index=0&id=284b0348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284b0348",
  null
  
)

export default component.exports